var link_viewer_wrapper_rtlignore_default = {
  "anchor": "mp77b",
  "link": "nlit-"
};
export {
  link_viewer_wrapper_rtlignore_default as default
};
//# sourceMappingURL=link-viewer-wrapper.rtlignore-scss.js.map
